module.exports = __webpack_public_path__ + "assets/line_icon.36c8567a.svg";